export * from './SmallInvestmentBanner'
